import Api from '@/services/api';
import {removeEmptyParams, transformDownloadResponse} from '@utils';
import contentDisposition from 'content-disposition';

export default {
  clients(filter) {
    return Api()
      .get('/clients', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  autocomplete(filter) {
    return Api()
      .get('/clients/autocomplete', {params: removeEmptyParams(filter)})
      .then((res) => res.data);
  },
  clientsPagination(filter) {
    return Api()
      .get('/clients/pagination', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach(this.formatRes);
        let response = {};
        response.data = res.data;
        response.totalItems = parseInt(res.headers['x-pagination-total']);
        return response;
      });
  },
  client(id) {
    return Api()
      .get('/client/' + id)
      .then((res) => res.data);
  },

  clientDisplay(id) {
    return Api()
      .get('/client/' + id + '/display')
      .then((res) => res.data);
  },
  create(client) {
    return Api()
      .post('/client', client)
      .then((res) => res.data);
  },
  exportList(filter) {
    return Api()
      .get('/clients/export', {
        responseType: 'blob',
        transformResponse: [transformDownloadResponse],
        params: removeEmptyParams(filter),
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let fileName = contentDisposition.parse(response.headers['content-disposition']).parameters.filename;
        link.setAttribute('download', fileName);
        link.click();
        window.URL.revokeObjectURL(url);
      });
  },
  update(client) {
    return Api()
      .put('/client/' + client.id, client)
      .then((res) => res.data);
  },
  updateEmail(employeeId, email) {
    return Api().put('/client/' + employeeId + '/email', {email: email});
  },
  delete(client) {
    return Api()
      .delete('/client/' + client.id)
      .then(() => client);
  },
  formatRes(e) {
    return e;
  },
};
